export default {
  API_ORIGIN: null,
  API_URL: null,
  urlParams: "",
  lastRequest: "",
  lastMapRequest: "",
  mainRequest: "",
  mapItems: [],
  searchId: 0,
  searched: false,
  searchedSecondFilters: false,
  tourSearchData: null,
  searchResult: [],
  priceTableData: null,
  priceTableDataCities: null,
  secondaryFiltersResult: null,
  cashSecondaryFiltersResult: null,
  userInfo: null,
  filterParams: {
    tourType: [],
    tourProgram: [],
    minPrice: null,
    maxPrice: null,
    tourCities: [],
    tourResort: [],
    tourCategory: [],
    tourFood: [],
    roomFeatures: [],
    tourHotelType: [],
    tourHotel: [],
    tourClass: [],
    tourClassMulty: false,
    tourTransplantation: [],
    tourDepartureAirports: [],
    tourArrivalAirports: [],
    tourAirlines: [],
    tourAirlineMulty: false,
    departureTime: [],
    arrivalTime: [],
    hotelQuota: 7,
    aviaQuota: 7,
    busTransferQuota: 7,
    railwayTransferQuota: 7,
  },
  tourForWebParams: null,
  minMaxPrice: [0, 0],
  minPrice: 0,
  maxPriceIsSet: false,
  outHotelMinPrice: 0,
  searchInOut: true,
  outHotelMode: true,
  mainSearchCount: 0,
  collpse: false,
  searchSecondParamsCounter: 0,
  firstSearch: false,
  firstSearchWithParams: false,
  clickSearch: false,
  showTourResultList: false,
  searchLoaderStatus: false,
  onMountedChangeDaysFlag: false,
  commonSearchFlag: false,
  searchOutHotelFlag: false,
  convertPriceFlag: true,
  checkFilterSelect: false,
  showCancellationPolicy: true,
  showTotalPrice: true,
  isAuthenticatedRecently: false
};
